import { Observable } from 'rxjs';

import { ChatConversacion } from '../../shared/interfaces/chat.interface';
import { CelulaContexto, CelulaPedidoTipo } from './celula.model';

/**
 * Contrato de la célula. Cada operación devuelve la lista completa.
 * La pantalla usa `CelulaService` (HTTP). El mock queda aparte, sin estar conectado.
 */
export abstract class CelulaDataSource {
  abstract contexto(): Observable<CelulaContexto>;
  abstract listar(): Observable<ChatConversacion[]>;
  abstract enviarMensaje(personaId: string, nota: string): Observable<ChatConversacion[]>;
  abstract marcarLeidos(personaId: string): Observable<ChatConversacion[]>;
  abstract crearSolicitud(
    personaId: string,
    tipo: CelulaPedidoTipo,
    motivo: string,
  ): Observable<ChatConversacion[]>;
}
